<div class="loading-container" *ngIf="showSpinner">
  <div class="loading-gif">
    <img src="../assets/images/Spinner.gif">
  </div>
</div>

<div class="row mb-2 mt-2">
  <div class="col-md-3">
    <div class="h-100 d-flex align-items-start flex-column">
        <form class="mb-auto w-100" [formGroup]="form" (ngSubmit)="populateTableData()">
          <label for="aviClientSel">Avi Customer ID</label>
          <ng-select 
            formControlName="clientId"
            id="aviClientSel"
            [virtualScroll]="true"
            [items]="sharedDataService.allClientParties"
            bindValue="clientParty.mailStop"
            [searchFn]="matchClientPartyRow"
            bindLabel="partyName"
            >
            <ng-template ng-option-tmp let-item="item">
                {{item.clientParty.mailStop}} -- {{item.partyName}}
            </ng-template>
          </ng-select>  
          <div class="marg-top">
            <label for="monthsel">Month</label>
            <select fxFlex="100" class="form-control"
                    formControlName="month"
                    id="monthsel">
              <option [value]="" disabled> -- Choose Month --</option>
              <option *ngFor="let month of months" [ngValue]="month.id">{{month.name}}</option>
            </select>
          </div>
          <div class="marg-top">
            <label for="yearsel">Year</label>
            <select fxFlex="100" class="form-control"
                    formControlName="year"
                    id="yearsel">
              <option [value]="" disabled> -- Choose Year --</option>
              <option *ngFor="let year of years" [ngValue]="year">{{year}}</option>
            </select>
          </div>
          <div class="mt-3">
            <button class="btn btn-primary w-100" type="submit">
              Find Files
            </button>
          </div>
        </form>
        <div class="w-100" [ngClass]="{'disabled': !uploadEnabled}">
          <h6> Upload / Overwrite Client File </h6>
          <client-files-upload (update)="populateTableData()" [year]="this.form.value.year" [month]="this.form.value.month" [clientId]="this.form.value.clientId"></client-files-upload>
        </div>
    </div>
  </div>
  <div class="col-md-9" [ngClass]="{'disabled': !hasLookedUpClient}">
    <div class="col-md-12">
      <ngx-datatable
      name="clientFilesTable"
      class="material striped"
      style="height: calc(100vh - 180px)"
      [columnMode]="'force'"
      [columns]="columns"
      [count]="rows.length"
      [headerHeight]="50"
      [footerHeight]="false"
      [rowHeight]="rowHeight"
      [rows]="rows"
      [scrollbarV]="true"
      [virtualization]="false"
      [selectionType]="'single'"
      [selected]="selected"
      (activate)="handleSelect($event)"
      ></ngx-datatable>
    </div>
  </div>
</div>


